module.exports = __webpack_public_path__ + "img/parent-avatar.7bdb7c2a.svg";